import axios from "axios";
import {config} from "./_config"
import { AwsApiService } from './_baseService';

export const uploadFile = async (formName, utrn, fileName, data) => {
    const lambdaUrl = new URL(`${config.awsBaseUrl}${config.fileUpload.presignedUrl}`);
    lambdaUrl.searchParams.append('formname', formName);
    lambdaUrl.searchParams.append('utrn', utrn);
    lambdaUrl.searchParams.append('filename', fileName);

    // Get presigned URL for upload to S3
    const presignedUrlresult = await AwsApiService.get(lambdaUrl, {
        headers: { 'x-api-key': config.apiGatewayKey }
    })
        .catch(error => {
            console.error(error.response.data, {request: error.request});
            return false;
        });

    const presignedUrl = presignedUrlresult.data;
    console.log("presignedUrlresult.data = " + presignedUrlresult.data);
    if(!presignedUrlresult || !presignedUrlresult.data){
        return false;
    }

    // Upload file data using presigned URL
    // Put service not used as base URL not required when using presigned URL
    const uploadResult = await axios.put(presignedUrl.Url, data)
        .catch(error => {
            console.error(error.response.data, {request: error.request})
            return false;
        });

    console.log("uploadResult status: " + uploadResult.status);
    if(uploadResult.status === 200)
        return true

    return false;
};
